var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

import { observable } from "mobx";
import { Application } from "../../application/application";

var BasicPagePresenter =
/** @class */
function () {
  function BasicPagePresenter(_router) {
    var _this = this;

    this._router = _router;
    this.loading = false;

    this.mount = function () {};

    this.unmount = function () {};

    this.back = function (e) {
      e.preventDefault();

      _this._router.history.goBack();
    };

    this.history = this._router.history;
    Application.router = this._router;
  }

  __decorate([observable], BasicPagePresenter.prototype, "loading", void 0);

  return BasicPagePresenter;
}();

export { BasicPagePresenter };